import config from "../config";
import http from "../utils/http";

const get = async () => {
  const url = `${config.baseUrl}${config.endPoints.bed.get}`;
  return http.get(url);
};

const create = async (data: {
  total: number;
  available: number;
  occupied: number;
}) => {
  const url = `${config.baseUrl}${config.endPoints.bed.create}`;
  return http.post(url, data);
};

const update = async (
  type: string,
  data: {
    total: number;
    available: number;
    occupied: number;
  }
) => {
  const url = `${config.baseUrl}${config.endPoints.bed.update(type)}`;
  return http.put(url, data);
};

const bedStatusService = {
  get,
  update,
  create,
};

export default bedStatusService;
